// extracted by mini-css-extract-plugin
export default {"wrapper":"Box_wrapper__GiLA4","inner":"Box_inner__jyduP","dark":"Box_dark__IHM2o","loading":"Box_loading__xJ4Te"};